import * as R from 'ramda';
import React from 'react';
import Icon from '../icon';

const BreadcrumbSeparator = () => <Icon>chevron_right</Icon>;

const Breadcrumbs = ({ children }) => (
  <span className="breadcrumbs">
    {React.Children.map(R.dropLast(1, children), child => [
      child,
      <BreadcrumbSeparator />,
    ])}
    {R.last(children)}
  </span>
);

export default Breadcrumbs;
